import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import "./Paypal.css";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageSubHeading from "../../../../components/CommonComponents/MessageSubHeading";
import { BiLinkExternal } from "react-icons/bi";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminCustomSelect from "../../../../components/CommonComponents/AdminCustomSelect";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import DeviceSelector from "../../../../components/PaymentComponents/DeviceSelector";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";

function Paypal() {
  const { fetchRequest } = useMyContext()
  const [formData, setFormData] = useState({})
  const [formDataError, setFormDataError] = useState({})
  const [loading, setLoading] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);

  // Supported devices from backend helper
  const [supportedDevices, setSupportedDevices] = useState(['web', 'Android', 'iOS', 'TV']);

  const combinedRef = useRef({});

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }
    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (value == 1) {
        setFormDataError((prev) => ({
          ...prev,
          test_paypal_password: "",
          test_paypal_username: "",
        }));
      }
      if (value == 0)
        setFormDataError((prev) => ({
          ...prev,
          live_paypal_password: "",
          live_paypal_username: ""
        }));
    }
  };

  const handleDeviceChange = (updatedDevices) => {
    // Filter only valid devices and ensure it's an array
    const validDevices = Array.isArray(updatedDevices) 
      ? updatedDevices.filter(device => supportedDevices.includes(device))
      : [];
      
    console.log('PayPal Device change:', { updatedDevices, validDevices, supportedDevices });
    
    setFormData((prev) => ({
      ...prev,
      supported_devices: validDevices
    }));
  };

  const formValidation = () => {
    let formIsValid = true;
    
    // Validate supported devices
    if (!formData?.supported_devices || !Array.isArray(formData.supported_devices) || formData.supported_devices.length === 0) {
      toast.warning('Please select at least one supported device.');
      formIsValid = false;
    }
    if (formData?.payment_mode == 0) {

      if (!formData?.test_paypal_username) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_paypal_username: "Test PayPal Client ID cannot be empty.",
        }));
        combinedRef.current['test_paypal_username'].focus()
        formIsValid = false;
      }
      if (!formData?.test_paypal_password) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_paypal_password: "Test PayPal Secret cannot be empty.",
        }));
        combinedRef.current['test_paypal_password'].focus()
        formIsValid = false;
      }
      if (!formData?.test_webhook_id) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_webhook_id: "Test Webhook ID cannot be empty.",
        }));
        combinedRef.current['test_webhook_id'].focus()
        formIsValid = false;
      }
    }
    if (formData?.payment_mode == 1) {

      if (!formData?.live_paypal_username) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_paypal_username: "Live PayPal Client ID cannot be empty.",
        }));
        combinedRef.current['live_paypal_username'].focus()
        formIsValid = false;
      }
      if (!formData?.live_paypal_password) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_paypal_password: "Live PayPal Secret cannot be empty.",
        }));
        combinedRef.current['live_paypal_password'].focus()
        formIsValid = false;
      }
      if (!formData?.live_webhook_id) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_webhook_id: "Live Webhook ID cannot be empty.",
        }));
        combinedRef.current['live_webhook_id'].focus()
        formIsValid = false;
      }
    }

    return formIsValid;
  }

  const handleStore = async () => {
    console.log('PayPal Form data before validation:', formData);
    if (formValidation()) {
      setLoading(true)
      const dataToSend = {
        ...formData,
        supported_devices: JSON.stringify(formData.supported_devices || [])
      };
      console.log('PayPal Data being sent:', dataToSend);
      
      await fetchRequest({
        method: 'POST',
        url: `${process.env.REACT_APP_Baseurl}/admin/paypal_payment/store`,
        params: {},
        data: dataToSend,
      })
        .then(response => {
          if (response?.status) {
            toast.success(response?.message)
            setWithOutRefresh((prev) => !prev)
          }
        }).catch((error => {
          toast.error(error?.response?.data?.message)
        })).finally(() => {
          setLoading(false)
        })
      // }
    }
  }

  useEffect(async () => {
    setShowOverlay(true)

    // Fetch supported devices from backend
    try {
      const deviceResponse = await fetchRequest({
        method: 'GET',
        url: `${process.env.REACT_APP_Baseurl}/admin/supported-devices`,
        params: {},
        data: {},
      });

      if (deviceResponse?.status && deviceResponse?.data) {
        setSupportedDevices(deviceResponse.data);
      }
    } catch (error) {
      console.warn('Using default supported devices:', error);
    }

    await fetchRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_Baseurl}/admin/paypal_payment/index`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          const paypalData = response?.paypal_payment;
          let deviceArray = []; // default

          // Parse supported_devices if it exists
          if (paypalData?.supported_devices) {
            try {
              const parsedDevices = typeof paypalData.supported_devices === 'string' 
                ? JSON.parse(paypalData.supported_devices)
                : paypalData.supported_devices;
              deviceArray = Array.isArray(parsedDevices) ? parsedDevices : [];
              console.log('PayPal Loaded devices:', deviceArray);
            } catch (error) {
              console.warn('Invalid supported_devices format:', paypalData.supported_devices);
              deviceArray = [];
            }
          }

          setFormData((prev) => ({
            ...prev,
            ...paypalData,
            supported_devices: deviceArray
          }));
        }
      }).catch((error => {
        toast.error(error?.response?.data?.message)
      })).finally(() => {
        setShowOverlay(false)
      })
  }, [withOutRefresh]);

  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminBackNavigation id="playout-backbtn" path="/payment_settings" text="Back" />
      <AdminSaveHeader heading={"PayPal Payment"} saveText={"Update PayPal"} saveMethod={handleStore} loading={loading} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="PayPal Configuration" />
            <Link to="https://www.paypal.com/us/home" target="_blank" className="d-inline-flex  align-items-center gap-2 p-2 rounded-2 shadow mb-4">
              <MessageSubHeading text="https://www.paypal.com/us/home" noMargin />
              <BiLinkExternal className="text-dark ms-2" />
            </Link>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Paypal Mode"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'status'} checked={formData?.status == 1} onChange={handleInput} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-7 col-md-7 pe-2">
                <MessageLabel text={"Enable Payment Mode"} />
              </div>
              <div className="col-3 col-md-3 ps-2 text-end">
                <AdminCustomSelect className="payment-mode-custom-select " name="payment_mode" value={formData?.payment_mode} onChange={handleInput} ref={(el) => (combinedRef.current.payment_mode = el)} options={[{ name: "TEST", value: 0 }, { name: "LIVE", value: 1 }]} error={""} defaultOptionName={""}  />
              </div>
            </div>
            <MessageLabel text={"PayPal Label"} className="" />
            <AdminCustomInput type="text" name="paypal_label" value={formData?.paypal_label} onChange={handleInput} placeHolder={"PayPal label"} ref={(el) => (combinedRef.current.paypal_label = el)} error={formDataError?.paypal_label} />
          </Wrapper>
          <Wrapper>
            <DeviceSelector
              selectedDevices={formData?.supported_devices || []}
              onDeviceChange={handleDeviceChange}
              gatewayName="paypal"
              availableDevices={supportedDevices}
              showDescriptions={true}
              label="Supported Devices"
              showSelectAll={true}
              className=""
              cardStyle="default"
              showDeviceStats={true}
            />
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
        <Wrapper>
            <MessageHeading text="PayPal Key Details (TEST)" />
            <MessageLabel text={"Test PayPal Client ID"} className="" />
            <AdminCustomInput type="text" name="test_paypal_username" value={formData?.test_paypal_username} onChange={handleInput} placeHolder={"test paypal client id"} ref={(el) => (combinedRef.current.test_paypal_username = el)} error={formDataError?.test_paypal_username} />
            <MessageLabel text={"Test PayPal Secret"} className="" />
            <AdminCustomInput type="text" name="test_paypal_password" value={formData?.test_paypal_password} onChange={handleInput} placeHolder={"test paypal secret"} ref={(el) => (combinedRef.current.test_paypal_password = el)} error={formDataError?.test_paypal_password} />
            <MessageLabel text={"Test Webhook ID"} className="" />
            <AdminCustomInput type="text" name="test_webhook_id" value={formData?.test_webhook_id} onChange={handleInput} placeHolder={"test webhook id"} ref={(el) => (combinedRef.current.test_webhook_id = el)} error={formDataError?.test_webhook_id} />
          </Wrapper>
          <Wrapper>
            <MessageHeading text="PayPal Key Details (LIVE)" />
            <MessageLabel text={"Live PayPal Client ID"} className="" />
            <AdminCustomInput type="text" name="live_paypal_username" value={formData?.live_paypal_username} onChange={handleInput} placeHolder={"live paypal client id"} ref={(el) => (combinedRef.current.live_paypal_username = el)} error={formDataError?.live_paypal_username} />
            <MessageLabel text={"Live PayPal Secret"} className="" />
            <AdminCustomInput type="text" name="live_paypal_password" value={formData?.live_paypal_password} onChange={handleInput} placeHolder={"live paypal secret"} ref={(el) => (combinedRef.current.live_paypal_password = el)} error={formDataError?.live_paypal_password} />
            <MessageLabel text={"Live Webhook ID"} className="" />
            <AdminCustomInput type="text" name="live_webhook_id" value={formData?.live_webhook_id} onChange={handleInput} placeHolder={"live webhook id"} ref={(el) => (combinedRef.current.live_webhook_id = el)} error={formDataError?.live_webhook_id} />
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={"Update PayPal"} loading={loading} />
      </FormContainer>
    </>
  );
}
export default Paypal;